/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import IntegrationsConstants from 'constants/IntegrationsConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'

const IntegrationsQueries = Marty.createQueries({
  id: 'IntegrationsQueries',

  mapSlackUser(slackUserId) {
    const promise = this.app.sources.IntegrationsAPI.mapSlackUser(slackUserId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.MAP_SLACK_USER_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.MAP_SLACK_USER_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.MAP_SLACK_USER_FAILED, error)
    })
  },

  createSlackBotToken(code, href) {
    const promise = this.app.sources.IntegrationsAPI.createSlackBotToken(code, href)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.CREATE_ACCESS_TOKEN_DONE, 'slack', name, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.CREATE_ACCESS_TOKEN_FAILED, 'slack', name, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.CREATE_ACCESS_TOKEN_FAILED, 'slack', name, error)
    })
  },

  createAccessToken(name, body) {
    const promise = this.app.sources.IntegrationsAPI.createAccessToken(name, body)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.CREATE_ACCESS_TOKEN_DONE, name, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.CREATE_ACCESS_TOKEN_FAILED, name, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.CREATE_ACCESS_TOKEN_FAILED, name, error)
    })
  },

  fetchIntegrationStates() {
    const promise = this.app.sources.IntegrationsAPI.integrationStates()

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.FETCH_INTEGRATION_STATES_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.FETCH_INTEGRATION_STATES_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.FETCH_INTEGRATION_STATES_FAILED, error)
    })
  },

  enableShopifyIntegration() {
    let promise
    return promise = this.app.sources.IntegrationsAPI.enableShopifyIntegration()
  },

  fetchHubspotInjectionState() {
    const promise = this.app.sources.IntegrationsAPI.hubspotInjectionState()

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_INJECTION_STATE_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_INJECTION_STATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_INJECTION_STATE_FAILED, error)
    })
  },

  fetchHubspotTimelineState() {
    const promise = this.app.sources.IntegrationsAPI.hubspotTimelineState()

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_TIMELINE_STATE_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_TIMELINE_STATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_TIMELINE_STATE_FAILED, error)
    })
  },

  updateHubspotInjectionState(state) {
    const promise = this.app.sources.IntegrationsAPI.updateHubspotInjectionState(state)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_INJECTION_STATE_DONE, state)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_INJECTION_STATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_INJECTION_STATE_FAILED, error)
    })
  },

  updateHubspotTimelineState(state) {
    const promise = this.app.sources.IntegrationsAPI.updateHubspotTimelineState(state)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_TIMELINE_STATE_DONE, state)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_TIMELINE_STATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_TIMELINE_STATE_FAILED, error)
    })
  },

  fetchHubspotCookieState() {
    const promise = this.app.sources.IntegrationsAPI.hubspotCookieState()

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_COOKIE_STATE_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_COOKIE_STATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.FETCH_HUBSPOT_COOKIE_STATE_FAILED, error)
    })
  },

  updateHubspotCookieState(state) {
    const promise = this.app.sources.IntegrationsAPI.updateHubspotCookieState(state)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_COOKIE_STATE_DONE, state)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_COOKIE_STATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.UPDATE_HUBSPOT_COOKIE_STATE_FAILED, error)
    })
  },

  updateIntegrationState(properties) {
    this.dispatch(IntegrationsConstants.UPDATE_INTEGRATION_STATE_STARTING, properties)

    const promise = this.app.sources.IntegrationsAPI.updateIntegrationState(properties)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.UPDATE_INTEGRATION_STATE_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.UPDATE_INTEGRATION_STATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.UPDATE_INTEGRATION_STATE_FAILED, error)
    })
  },

  fetchProtip(id) {
    const promise = this.app.sources.IntegrationsAPI.protip(id)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(IntegrationsConstants.FETCH_PROTIP_DONE, id, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(IntegrationsConstants.FETCH_PROTIP_FAILED, id, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(IntegrationsConstants.FETCH_PROTIP_FAILED, id, error)
    })
  }
})

export default IntegrationsQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/IntegrationsQueries.js